export default {
  // home

  // ui
  entrar: "Entra",
  play: "Riproduci",
  pause: "Pausa",
  subtitles: "Sottotitoli",
  pantalla_completa: "Schermo intero",
  salir_pantalla_completa: "Esci dalla modalità schermo intero",
  escena_completada: "Scena completata",

  // overlays
  r1_1: "A) Sì, sono coperture che vengono stipulate separatamente dalla polizza di base.",
  r1_2: "B) No, un'assicurazione casa di solito copre i danni causati dall'acqua, gli incendi, i furti e la responsabilità civile.",
  r1_3: "C) Sì, sono incluse in qualsiasi polizza casa standard.",

  r2_1: "A) Continua a crescere da solo, perché più tempo passa senza che nessuno lo tocchi, più aumenta.",
  r2_2: "B) Non cresce né perde valore, perché lasciarlo fermo non cambia nulla.",
  r2_3: "C) Se resta fermo, non cresce. Anzi, perde valore. Per generare un rendimento, deve essere investito in qualcosa che lo faccia fruttare.",

  r3_1: "A) L'immobile e tutto ciò che contiene, perché l'assicurazione calcola automaticamente ciò che acquisti, conservi o butti via ogni giorno.",
  r3_2: "B) L'immobile e ciò che contiene, anche se è necessario dichiarare il valore del contenuto.",
  r3_3: "C) Ciò che si trova all'interno; l'immobile è già coperto dalla banca al momento della concessione del mutuo.",

};